const NAME = 'users';
const PAGE_SIZE = 10;

export default {
  NAME,
  PAGE_SIZE,
};
